import * as React from 'react';

interface BounceLoaderProps {
	className?: string;
	caption?: string;
}

const BounceLoader: React.FC<BounceLoaderProps> = ({
	className = 'page-loading',
	caption = 'Loading',
}) => {
	return <div className={`loading-component ${className}`}>
		<div className="spinner">
			<div className="double-bounce1" />
			<div className="double-bounce2" />
		</div>
		<div className="loading-component__caption">
			{caption}
		</div>
	</div>;
};

export default BounceLoader;
